function sortAndOverrideActionOrder(actions) {
  var actionsWithOverrides = actions.filter(action => action.index !== undefined);

  if (actionsWithOverrides.length === 0) {
    return actions;
  }

  var sortedActionsWithOverrides = actionsWithOverrides.sort(({
    index: indexA
  }, {
    index: indexB
  }) => {
    return indexA - indexB;
  });
  var actionsWithoutOverrides = actions.filter(action => action.index === undefined);
  var overriddenActions = [...actionsWithoutOverrides];
  sortedActionsWithOverrides.forEach(action => {
    overriddenActions.splice(action.index, 0, action);
  });
  return overriddenActions;
}

export { sortAndOverrideActionOrder };
